module.exports = __webpack_public_path__ + "img/stock4.3b9e6fb3.png";